import React, { useEffect, useRef, useState } from "react";
import UseToggle from "../Hooks/UseToggle";
import ChangePassword from "../Components/Navbar/ChangePassword";
import TwoFactorAuth from "../Components/Navbar/TwoFactorAuth/TwoFactorAuth";
import { Button, Collapse, ListGroup } from "react-bootstrap";
import UserProfile from "./Modules/Auth/UserProfile/UserProfile";
import { userServices } from "../APIServices/userServices";

const ProfileActions = ({ firstName, lastName, handleAddNewTab }) => {
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } =
    UseToggle();

  const [authType, setAuthType] = useState("");
  const [authTypeData, setAuthTypeData] = useState("");
  const [status, setStatus] = useState(false);
  const [appTwoFA, setAppTwoFA] = useState(false);
  const [notification, setNotification] = useState("");
  const [emailTwoFA, setEmailTwoFA] = useState(false);

  const AppsRef = useRef(null);
  const NotificationRef = useRef(null);
  const [AppsActive, setAppsActive] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const getTwoFactorAuthType = async () => {
    let data = await userServices.getTwoFactorAuthType();
    setAuthType(data?.authType);
    setAuthTypeData(data?.authType);
    setStatus(data?.status);
    setAppTwoFA(data?.appTwoFA);
    setEmailTwoFA(data?.emailTwoFA);
  };

  const openTwoFactorAuth = () => {
    getTwoFactorAuthType();
    setToggle2();
  };

  let currentURL = window.location.href
  let splitCurrentURL = currentURL?.split("/")

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (NotificationRef.current && !NotificationRef.current.contains(event.target)) {
        setNotification("");
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    getTwoFactorAuthType();
  }, []);

  return (
    <>
      <div ref={NotificationRef}>
        <Button className="position-relative border-0 py-1 px-2 br3" variant="outline-light" onClick={() => setNotification(!notification)}>
          <div className="hstack gap-1">
            <i className="fa-solid fa-bell text-info position-relative" style={{fontSize: 15}}></i>
            {/* <i className="fa-solid fa-circle position-absolute" style={{ fontSize: 6, top: 5, left: 17 }}></i> */}
          </div>
        </Button>
      </div>
      <div ref={AppsRef}>
        <Button className="position-relative border-0 py-1 px-2 text-start br3" variant="outline-light" onClick={() => setAppsActive(!AppsActive)}>
          <div className="hstack gap-1">
            <i className="fa-solid fa-user-tie me-1 text-info" style={{fontSize: 14}}></i>
            <p className="m-0" style={{ fontSize: 13 }}>{`${firstName} ${lastName}`}</p>
            <i className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`} style={{fontSize: 12}}></i>
          </div>
          <Collapse in={AppsActive === true}>
            <div className="position-absolute z-1 end-0" style={{top: 33}}>
              <ListGroup style={{fontSize: 12, width: "max-content"}}>
                <ListGroup.Item action onClick={setToggle} ><i className="fa-solid fa-address-card me-2"></i>Profile</ListGroup.Item>
                <ListGroup.Item action onClick={setToggle1}><i className="fa-solid fa-unlock-keyhole me-2"></i>Change Password</ListGroup.Item>
                <ListGroup.Item action onClick={openTwoFactorAuth}> <i className="fa-solid fa-shield-halved me-2"></i>Two Factor Auth</ListGroup.Item>
              </ListGroup>
            </div>
          </Collapse>
        </Button>
      </div>

      <UserProfile SHOW={!toggle} HIDE={setToggle} TITLE={"User Profile"} />

      <ChangePassword
        SHOW={!toggle1}
        HIDE={setToggle1}
        TITLE={"Change Password"}
      />

      <TwoFactorAuth
        SHOW={!toggle2}
        HIDE={setToggle2}
        TITLE={"Two Factor Auth"}
        getTwoFactorAuthType={getTwoFactorAuthType}
        setAuthType={setAuthType}
        authType={authType}
        authTypeData={authTypeData}
        status={status}
        appTwoFA={appTwoFA}
        emailTwoFA={emailTwoFA}
      />
    </>
  );
};

export default ProfileActions;
